import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const Profile = () => {
    return (
        <div id="profile-login-page">
            <ul className="list-unstyled">
                <li className="xpy-2">
                    <a href="#" className="xpt-2 xpx-2 position-relative xmt-3">
                        <div className="icon-link user-link position-absolute">
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                        <div className="text-profile d-flex align-items-center">
                            <div className="img">
                                <img src="./assets/sample-image/vahid-namvari-gray copy-7.png" alt="user"/>
                            </div>
                            <div className="description">
                                <span className="name d-block">وحید ناموری</span>
                                <span className="phone-number persian-number">09206268274</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li className="xpy-2">
                    <a href="#" className="xpy-2 xpx-4 position-relative ">
                        <div className="icon-link position-absolute">
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                        <div className="text-profile d-flex align-items-center">
                            <div className="icon">
                                <IconName name="receipt" className="icon"/>
                            </div>
                            <div className="description">
                                <span className="name">سفارش های من</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li className="xpy-2">
                    <a href="#" className="xpy-2 xpx-4 position-relative ">
                        <div className="icon-link position-absolute">
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                        <div className="text-profile d-flex align-items-center">
                            <div className="icon">
                                <IconName name="settings" className="icon"/>
                            </div>
                            <div className="description">
                                <span className="name"> تنظیمات</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li className="xpy-2">
                    <a href="#" className="xpy-2 xpx-4 position-relative ">
                        <div className="switch-button position-absolute">
                            <div className="form-check form-switch">
                                <input className="form-check-input dark-mode-switch" type="checkbox" role="switch"/>
                            </div>
                        </div>
                        <div className="text-profile d-flex align-items-center">
                            <div className="icon dark-icon">
                                <IconName name="darkmode"/>
                            </div>
                            <div className="description">
                                <span className="name">حالت تاریک</span>
                            </div>
                        </div>
                    </a>
                </li>
                <li className="xpy-2 log-out-profile">
                    <a href="#" className="xpt-2 xpx-4 position-relative ">
                        <div className="text-profile d-flex align-items-center">
                            <div className="icon">
                                <IconName name="exit" className="icon"/>
                            </div>
                            <div className="description">
                                <span className="name">خروج از حساب کاربری</span>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    );
};

export default Profile;
